export default __webpack_public_path__ + "static/media/waiting_for_payment.b2fe6a6c.svg";